(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("angular"), require("blob-util"), require("blueimp-load-image/js/load-image.all.min"));
	else if(typeof define === 'function' && define.amd)
		define(["angular", "blob-util", "blueimp-load-image/js/load-image.all.min"], factory);
	else if(typeof exports === 'object')
		exports["ahdin"] = factory(require("angular"), require("blob-util"), require("blueimp-load-image/js/load-image.all.min"));
	else
		root["ahdin"] = factory(root["angular"], root["blobUtil"], root["loadImage"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/